import { useSessionWithUser } from "src/components/session/session";
import { ShowStatus } from "../types";
import { useIsFeatureEnabled } from "src/hooks/useIsFeatureEnabled";
import {
  tryLocalStorageGetItem,
  tryLocalStorageSetItem,
} from "src/utils/storage/storage";
import { useTeamToJoin } from "./useTeamToJoin";
import { useHasMembershipForSuggestedTeam } from "./useHasMembershipForSuggestedTeam";
import { useState } from "react";
import { SuggestTeamBannerProps } from "./SuggestTeamBanner";

const SUGGEST_TEAM_NOTIFICATION = "suggestTeamNotificationDismissed";

export function useShouldShowSuggestTeamBanner(): [
  ShowStatus,
  SuggestTeamBannerProps | null,
] {
  const session = useSessionWithUser();
  const isFlagEnabled = useIsFeatureEnabled("show-requests-to-join-team");
  const ignoredDate = tryLocalStorageGetItem(SUGGEST_TEAM_NOTIFICATION);

  const teamToJoin = useTeamToJoin(session);
  const hasMembershipForSuggestedTeam = useHasMembershipForSuggestedTeam(
    teamToJoin?.id
  );
  const dismissed = promptWasDimissedLessThanThreeMonthsAgo(ignoredDate);
  const [isDismissed, setIsDismissed] = useState(dismissed);
  const isEnabled =
    isFlagEnabled && session !== undefined && !hasMembershipForSuggestedTeam;
  const isVisible = isEnabled && !isDismissed && teamToJoin !== undefined;
  if (isVisible) {
    return [
      "show",
      {
        teamToJoin,
        onDismiss: () => {
          setIsDismissed(true);
          tryLocalStorageSetItem(
            SUGGEST_TEAM_NOTIFICATION,
            new Date().toISOString()
          );
          setIsDismissed(true);
        },
      },
    ];
  }
  return ["dont-show", null];
}

function promptWasDimissedLessThanThreeMonthsAgo(date: string | null): boolean {
  if (date === null) {
    return false;
  }
  const providedDate = new Date(date);
  const currentDate = new Date();

  // Calculate the date 3 months ago from the current date
  const threeMonthsAgo = new Date();
  threeMonthsAgo.setMonth(currentDate.getMonth() - 3);

  return providedDate >= threeMonthsAgo;
}
